<div class="appointment-booking-wizard-callout borderless">
  <div class="message message-warning">
    <p><%= I18n.errors.recoverable.base_epic_invalid_patient_name_error %></p>
  </div>
</div>

<div class="step-form">
  <div class="fieldset">
    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.first_name %></label>
      <input type="text" name="sparklehp" tabindex="-1" autocomplete="sparklehp" data-appointment-booking-wizard-behaviour="field-input"/>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="first_name" required placeholder="<%= I18n.placeholders.required %>" value="<%- first_name %>">
      <span class="validation-error"><%= I18n.errors.incorrect_format.first_name %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.last_name %></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="last_name" required placeholder="<%= I18n.placeholders.required %>" value="<%- last_name %>">
      <span class="validation-error"><%= I18n.errors.incorrect_format.last_name %></span>
    </div>
  </div>
</div>
